<template>
  <div class="filter-container">
    <vs-card class="filter-card">
      <form role="form" @submit.stop.prevent="buscar" @keyup.enter="buscar" class="filter-form">
        <!-- Filtros Básicos -->
        <h5 class="group-title">
          <i class="feather icon-user"></i>
          Dados Usuários
        </h5>
        <div class="filter-section">
          <div class="vx-row">
            <div class="vx-col lg:w-1/6 md:w-1/2 w-full">
              <div class="input-group">
                <label class="input-label">
                  <i class="feather icon-hash"></i>
                  Código
                </label>
                <vs-input class="w-full" name="codigo" id="codigo" v-model="formFiltro.idUsuario"
                  placeholder="Digite o código" />
              </div>
            </div>

            <div class="vx-col lg:w-1/6 md:w-1/2 w-full">
              <div class="input-group">
                <label class="input-label">
                  <i class="feather icon-user"></i>
                  Nome
                </label>
                <vs-input class="w-full" name="Nome" id="Nome" v-model="formFiltro.nome" placeholder="Digite o nome"
                  val-icon-danger="clear" danger-text="Preencha este Campo" />
              </div>
            </div>

            <div class="vx-col lg:w-1/6 md:w-1/2 w-full">
              <div class="input-group">
                <label class="input-label">
                  <i class="feather icon-credit-card"></i>
                  CPF
                </label>
                <vs-input class="w-full" name="CPF" id="CPF" v-model="formFiltro.cpf" placeholder="000.000.000-00"
                  val-icon-danger="clear" danger-text="Preencha este Campo" v-mask="'###.###.###-##'" />
              </div>
            </div>

            <div class="vx-col lg:w-1/6 md:w-1/2 w-full">
              <div class="input-group">
                <label class="input-label">
                  <i class="feather icon-mail"></i>
                  Email
                </label>
                <vs-input class="w-full" name="Email" id="Email" v-model="formFiltro.email"
                  placeholder="exemplo@email.com" val-icon-danger="clear" danger-text="Preencha este Campo" />
              </div>
            </div>

            <div class="vx-col lg:w-1/6 md:w-1/2 w-full">
              <div class="input-group">
                <label class="input-label">
                  <i class="feather icon-phone"></i>
                  Celular
                </label>
                <vs-input class="w-full" name="Celular" id="Celular" v-model="formFiltro.celular"
                  placeholder="(00) 00000-0000" val-icon-danger="clear" danger-text="Preencha este Campo"
                  v-mask="'(##) #####-####'" />
              </div>
            </div>

            <div class="vx-col lg:w-1/6 md:w-1/2 w-full">
              <div class="input-group">
                <label class="input-label">
                  <i class="feather icon-activity"></i>
                  Status
                </label>
                <v-select :options="status" name="Status" id="Status" v-model="formFiltro.status"
                  placeholder="Selecione o status" class="custom-select" />
              </div>
            </div>
          </div>
        </div>

        <!-- Filtros Avançados -->
        <div class="filter-section advanced-section" v-if="filtroAvancado">
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <div class="financial-group">
                <h5 class="group-title">
                  <i class="feather icon-dollar-sign"></i>
                  Faixa de Saldo
                </h5>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <div class="input-group">
                      <label class="input-label">Saldo Inicial</label>
                      <vs-input class="w-full" name="Saldo Inicial" id="Saldo Inicial" type="number"
                        v-model="formFiltro.saldoInicial" placeholder="0,00" val-icon-danger="clear"
                        danger-text="Preencha este Campo" />
                    </div>
                  </div>
                  <div class="vx-col w-1/2">
                    <div class="input-group">
                      <label class="input-label">Saldo Final</label>
                      <vs-input class="w-full" name="Saldo Final" id="Saldo Final" type="number"
                        v-model="formFiltro.saldoFinal" placeholder="0,00" val-icon-danger="clear"
                        danger-text="Preencha este Campo" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
              <div class="financial-group">
                <h5 class="group-title">
                  <i class="feather icon-zap"></i>
                  Faixa PIX Pagos
                </h5>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <div class="input-group">
                      <label class="input-label">PIX Inicial</label>
                      <vs-input class="w-full" name="Valor Pix Inicial" id="Valor Pix Inicial" type="number"
                        v-model="formFiltro.valorPixInicial" placeholder="0,00" val-icon-danger="clear"
                        danger-text="Preencha este Campo" />
                    </div>
                  </div>
                  <div class="vx-col w-1/2">
                    <div class="input-group">
                      <label class="input-label">PIX Final</label>
                      <vs-input class="w-full" name="Valor Pix Final" id="Valor Pix Final" type="number"
                        v-model="formFiltro.valorPixFinal" placeholder="0,00" val-icon-danger="clear"
                        danger-text="Preencha este Campo" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Footer com Botões -->
      <div slot="footer" class="card-footer">
        <div class="action-buttons">
          <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search" class="btn-primary"
            @click="buscar">
            Buscar
          </vs-button>

          <vs-button @click="buscaFiltrosAvancados()" type="gradient" color="dark" icon-pack="feather"
            :icon="filtroAvancado ? 'icon-chevron-up' : 'icon-sliders'" class="btn-secondary">
            {{ filtroAvancado ? 'Ocultar' : 'Mais Filtros' }}
          </vs-button>

          <vs-button @click="limparFiltro" color="danger" type="gradient" icon-pack="feather" icon="icon-trash-2"
            class="btn-danger">
            Limpar
          </vs-button>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../services";
import jwt from "jsonwebtoken";

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      this.buscaDadosSelectsCidades(
        "domMunicipio",
        "cidades",
        "nomeCidade",
        "idCidade"
      );
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      regionalDefault: [],
      regionaisUsuario: [],
      cidades: [],
      grupos: [],
      regionais: [],
      usuarios_regionais: [],
      consultores: [],
      languages: lang,
      filtroAvancado: false,
      status: ["Todos", "Ativo", "Inativo"],
      tiposDatas: ["Data Cadastro", "Data Vistoria"],
      listaSimNao: ["Sim", "Não"],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idEmpresa: null,
        cpf: "",
        nome: null,
        consultor: null,
        status: null,
        cidade: "",
        estado: "",
        tipoData: "Data Cadastro",
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idUsuario: null,
        saldoInicial: null,
        saldoFinal: null,
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        cpf: null,
        nome: null,
        consultor: null,
        status: null,
        cidade: "",
        estado: "",
        tipoData: "Data Cadastro",
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idUsuario: null,
      };
      this.buscar();
    },
    getDecoded() {
      const token = localStorage.getItem("user-token");
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
    buscaDadosRegionais() {
      service
        .getAll("Usuario", {}, "list/idEmpresa=" + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.idUsuario == this.id_usuario) {
              if (element.usuarios_regionais.length > 0) {
                this.usuarios_regionais = element.usuarios_regionais;
                this.usuarios_regionais.forEach((elementSel) => {
                  this.regionaisUsuario.push({
                    id: elementSel.id_regional,
                    label: elementSel.nome,
                  });
                  this.idRegionais = this.regionais.map((item) => item.id);
                });
                this.regionais = this.regionaisUsuario.concat(
                  this.regionalDefault
                );
              } else {
                var usuarios_regionais = element.Usuarios_Regional;
                this.regionais.push({
                  id: usuarios_regionais.idRegional,
                  label: usuarios_regionais.nome,
                });
                this.idRegionais = this.regionais.map((item) => item.id);
              }
            }
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == "status" && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosGrupos() {
      service
        .getAll("Grupo", {}, "list/idEmpresa=" + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.grupos.push({
              id: element.idGrupo,
              label: element.nomeGrupo,
            });
          });
        });
    },
    buscaDadosConsultor() {
      service
        .getAll("Usuario", {}, "list/idEmpresa=" + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.consultores.push({
              id: element.idUsuario,
              label: element.nome,
            });
          });
        });
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll("g", {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              console.log(element[campoPK], this.decoded.id_regional);
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll("g", {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });
          this.$vs.loading.close();
        });
    },
    buscaDadosAtivosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .post(model, `list`, {
          idEmpresa: this.idEmpresa,
          notDeleted: true,
          tipoStatus: "ASSOCIADOS",
        })
        .then((res) => {
          this[array].push({ label: "Selecionar Todos", id: 0 });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    async buscaFiltrosAvancados() {
      this.filtroAvancado = !this.filtroAvancado;
    },
    buscar() {
      this.$emit("filtro", this.formFiltro);
    },
  },
  mounted() {
    this.getDecoded();
  },
  components: {
    "v-select": vSelect,
  },
};
</script>

<style scoped>
.filter-container {
  width: 100%;
  margin: 0 auto;
}

.filter-card {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
}

.filter-section {
  margin-bottom: 2rem;
}

.filter-section:last-child {
  margin-bottom: 0;
}

.advanced-section {
  border-top: 1px solid #e2e8f0;
  padding-top: 8px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.group-title {
  font-size: 1rem;
  font-weight: 600;
  color: #334155;
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.card-footer {
  border-top: 1px solid #e2e8f0;
  margin-bottom: 30px;
  padding: 10px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary,
.btn-danger {
  min-width: 120px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .filter-form {
    padding: 1rem;
  }

  .action-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-primary,
  .btn-secondary,
  .btn-danger {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}

/* Vue Select Customization */
.custom-select {
  font-family: inherit;
}

.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.vs__dropdown-toggle:hover {
  border-color: #cbd5e1;
}

.vs__dropdown-toggle:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}

/* Input Styling */
.vs-input {
  transition: all 0.3s ease;
}

.vs-input:focus {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
